import React from 'react';
import {
  Create,
  DeleteWithConfirmButton,
  DisabledInput,
  Edit,
  EditButton,
  List,
  NumberInput,
  SaveButton,
  SimpleForm,
  TextField,
  TextInput,
  Toolbar
} from 'react-admin';

import { defaultListProps } from '~constants/config';
import CustomDatagrid from '~components/CustomDatagrid';
import FieldGroup from '~components/FieldGroup';
import { isRequired } from '~utils/inputValidations';

// Fuentes are the Plan Maestro studies. Besides the translated name they carry the public
// Home tab they get: its order and a short label (the full name is used when empty).

function FuenteToolbar(props) {
  return (
    <Toolbar {...props}>
      <SaveButton />
    </Toolbar>
  );
}

function FuenteForm({ children, ...props }) {
  return (
    <SimpleForm {...props} toolbar={<FuenteToolbar />}>
      {children}
      <FieldGroup label="fieldGroups.catalogEs">
        <TextInput source="name" validate={isRequired} />
        <TextInput source="shortName" />
      </FieldGroup>
      <FieldGroup label="fieldGroups.catalogEn">
        <TextInput source="nameEn" />
        <TextInput source="shortNameEn" />
      </FieldGroup>
      <FieldGroup label="fieldGroups.catalogPt">
        <TextInput source="namePt" />
        <TextInput source="shortNamePt" />
      </FieldGroup>
      <FieldGroup label="fieldGroups.fuenteTab">
        <NumberInput source="order" min={0} />
      </FieldGroup>
    </SimpleForm>
  );
}

export function FuenteList(props) {
  return (
    <List {...defaultListProps} {...props} sort={{ field: 'order', order: 'ASC' }}>
      <CustomDatagrid rowClick="edit">
        <TextField source="order" sortable={false} />
        <TextField source="nameEs" sortable={false} />
        <TextField source="shortNameEs" sortable={false} />
        <DeleteWithConfirmButton label="" />
        <EditButton label="" />
      </CustomDatagrid>
    </List>
  );
}

export function FuenteCreate(props) {
  return (
    <Create {...props}>
      <FuenteForm redirect="list" />
    </Create>
  );
}

export function FuenteEdit(props) {
  return (
    <Edit undoable={false} {...props}>
      <FuenteForm redirect="list">
        <DisabledInput label="Id" source="id" />
      </FuenteForm>
    </Edit>
  );
}
